/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_User_FirstInputs */

const en_select_user_first = /** @type {(inputs: Select_User_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a user first`)
};

const es_select_user_first = /** @type {(inputs: Select_User_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero selecciona un usuario`)
};

/**
* | output |
* | --- |
* | "Please select a user first" |
*
* @param {Select_User_FirstInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_user_first = /** @type {((inputs?: Select_User_FirstInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_User_FirstInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_user_first(inputs)
	return es_select_user_first(inputs)
});